import React from 'react'
import SubHeader from '../../components/SubHeader'
import NewsCard from './NewsCard'

export default function News({ initialData }) {
    const subheadData = {
        image: '../assets/images/news-banner.webp',
        pagename: 'News',
        subhead: 'Latest updates, insights, and milestones from Supershine.',
    }

    return (
        <>
            <SubHeader subheadData={subheadData} />
            <NewsCard extraClass="news-card"  initialData={initialData} />
        </>
    )
}


